import clsx from 'clsx';

import type { ButtonProps } from 'components/atoms/Button';
import Button from 'components/atoms/Button';
import { twMerge } from '../../../../../utils/twMerge';
import { Close } from '../../Modal';
import { FOOTER_UI_COPY } from './Footer.uiCopy';

export interface Props {
  primary: Omit<ButtonProps, 'label'> & { label?: string };
  dismiss?: Omit<ButtonProps, 'label'> & { label?: string };
  secondary?: Omit<ButtonProps, 'label'> & { label?: string };
  className?: string;
}

export const Footer = ({ className, primary, dismiss, secondary }: Props) => {
  const hasDismiss = !!dismiss;
  const hasSecondary = !!secondary;

  return (
    <footer
      className={twMerge(
        clsx(
          'flex flex-row-reverse items-center justify-start gap-sm1',
          'pt-sm1',
          {
            'justify-between': hasDismiss,
          },
          className,
        ),
      )}
    >
      <div className="flex flex-row-reverse items-center gap-sm1">
        <Button
          type="button"
          variant="PRIMARY"
          {...primary}
          label={primary.label || FOOTER_UI_COPY.primary.label}
        />
        {hasSecondary && (
          <Button
            type="button"
            variant="SECONDARY"
            {...secondary}
            label={secondary.label || FOOTER_UI_COPY.secondary.label}
          />
        )}
      </div>
      {hasDismiss && (
        <Close
          render={props => (
            <Button
              type="button"
              variant="GHOST"
              {...props}
              {...dismiss}
              label={dismiss.label || FOOTER_UI_COPY.dismiss.label}
              onClick={event => {
                dismiss.onClick?.(event);
                props.onClick?.(event);
              }}
            />
          )}
        />
      )}
    </footer>
  );
};
